




























































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Navbar extends Vue {
  get isAuthenticated() {
    return this.$store.getters.isAuthenticated;
  }
  get isAdmin() {
    return this.$store.getters.isAdmin;
  }
  get user() {
    return this.$store.getters.getUser;
  }
  open = false;
  toggleNav() {
    this.open = !this.open;
  }

  scrollTo(route: string) {
    if (this.$router.currentRoute.name != "Home") this.$router.push("/home");
    const el = document.getElementById(route);
    if (el)
      el.scrollIntoView({
        behavior: "smooth",
      });
    this.open = false;
  }

  route(route: string) {
    this.$router.push("/" + route);
  }
  reload() {
    this.$router.push("/home");
  }

  logout() {
    this.$store.commit("setUser", {});
    this.$store.commit("setToken", null);
    this.$store.commit("authenticate", false);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    this.open = false;
    this.$router.push("/login");
  }
}
